import { Route, Routes } from "react-router-dom";
import { SuspenseLoader } from "../../../components/suspense-loader/SuspenseLoader";
import { CheckSignIn } from "./CheckSignIn";

const CheckSignInModule = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <SuspenseLoader>
            <CheckSignIn />
          </SuspenseLoader>
        }
      />
    </Routes>
  );
};

export default CheckSignInModule;
